import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach learner token when present
api.interceptors.request.use((config) => {
  const learnerToken = localStorage.getItem("dec_learner_token");
  if (learnerToken && !config.headers?.["X-Learner-Token"]) {
    config.headers = config.headers || {};
    config.headers["X-Learner-Token"] = learnerToken;
  }
  return config;
});
